import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=a07791cc&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"
import style0 from "./tools.vue?vue&type=style&index=0&id=a07791cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07791cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a07791cc')) {
      api.createRecord('a07791cc', component.options)
    } else {
      api.reload('a07791cc', component.options)
    }
    module.hot.accept("./tools.vue?vue&type=template&id=a07791cc&scoped=true", function () {
      api.rerender('a07791cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/main/src/page/chatPage/content/chat/tools.vue"
export default component.exports